import React from 'react';
import {shallowEqual, useSelector} from "react-redux";

function Geoportail5065(props){

    const geoportail5065 = useSelector(state => state.geoportail5065ApiReducer.geoportail5065 , shallowEqual)

    const google = window.google;
    const map = props.map;
    let geoportail5065Data;


    function geoportail5065Map(map) {
        if(map != null){
            console.log("geoportail5065", geoportail5065)
            if(geoportail5065){
                geoportail5065Data = new google.maps.ImageMapType({
                    maxZoom: 19,
                    minZoom: 0,
                    name: "Geoportail5065",
                    tileSize: new google.maps.Size(256, 256),
                    getTileUrl: function (coordinates, zoom) {
                        // Pour DEV
                        //return 'https://wxs.ign.fr/an7nvfzojv5wa96dsga5nk8w/geoportail/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&&LAYER=ORTHOIMAGERY.ORTHOPHOTOS.1950-1965&TILEMATRIXSET=PM&TILEMATRIX=' + zoom + '&TILECOL=' + coordinates.x + '&TILEROW=' + coordinates.y +'&STYLE=normal&FORMAT=image/png';

                        // Pour PROD
                        return 'https://wxs.ign.fr/0skh99buqiuj9k125e4d5q9h/geoportail/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&&LAYER=ORTHOIMAGERY.ORTHOPHOTOS.1950-1965&TILEMATRIXSET=PM&TILEMATRIX=' + zoom + '&TILECOL=' + coordinates.x + '&TILEROW=' + coordinates.y +'&STYLE=normal&FORMAT=image/png';
                    }
                });
                map.overlayMapTypes.insertAt(0, geoportail5065Data);
            }else{
                map.overlayMapTypes.forEach(function (object, index) {
                    map.overlayMapTypes.removeAt(index, geoportail5065Data);
                });
            }
        }
    }


    return(
        <div>
            {geoportail5065Map(map)}
        </div>
    )
}
export default React.memo(Geoportail5065);